import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import './product-list_title.scss';
import { PRODUCTS_LOAD_LIMIT } from '../productList/productList';

const ListTitle = ({ isHeader }) => {
  const { displayedItems, totalItems } = useSelector(state => state.products);

  if (totalItems === 0) {
    return null;
  }

  const cssClass = !isHeader ? '-hide' : '';

  const initialItems = totalItems > PRODUCTS_LOAD_LIMIT ? PRODUCTS_LOAD_LIMIT : totalItems;

  const showingNumberOfProducts = displayedItems > initialItems ? displayedItems : initialItems;

  return (
    <div className={`product-list__list-title--container${cssClass}`}>
      <div className="product-list__list-title">
        <p className="product-list__list-title--number">
          <FormattedMessage id="products.productgrid.showing"/> {showingNumberOfProducts} <FormattedMessage id="products"/>
        </p>
      </div>
    </div>
  );
};

ListTitle.defaultProps = {
  isHeader: true,
};

ListTitle.propTypes = {
  isHeader: PropTypes.bool,
};

export default ListTitle;
